import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import Questionnaire1Screen from '~/pages/homes/menstrual-health/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/menstrual-health/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/menstrual-health/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/menstrual-health/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/menstrual-health/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/menstrual-health/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/menstrual-health/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/menstrual-health/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/menstrual-health/Questionnaire9Screen';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {MENSTRUAL_HEALTH_KEYS} from '~/constants/medical-questionnaires';
import {trackPageViewGA} from '~/services/google-analytics';

const MenstrualHealth = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case MENSTRUAL_HEALTH_KEYS.START:
        trackPageViewGA('/menstrual-health/start', 'MDQ-Menstrual Health - Start');
        return <Questionnaire1Screen />;
      case MENSTRUAL_HEALTH_KEYS.PROFILE:
        trackPageViewGA('/menstrual-health/profile', 'MDQ-Menstrual Health - Profile');
        return <Questionnaire2Screen />;
      case MENSTRUAL_HEALTH_KEYS.INVALID:
        trackPageViewGA('/menstrual-health/invalid', 'MDQ-Menstrual Health - Invalid');
        return <Questionnaire3Screen />;
      case MENSTRUAL_HEALTH_KEYS.LAST_PERIOD_AT:
        trackPageViewGA('/menstrual-health/last-period-at', 'MDQ-Menstrual Health - Last Period At');
        return <Questionnaire4Screen />;
      case MENSTRUAL_HEALTH_KEYS.PERIODS_USUAL_LAST_FOR:
        trackPageViewGA('/menstrual-health/periods-usual-last-for', 'MDQ-Menstrual Health - Periods Usual Last For');
        return <Questionnaire5Screen />;
      case MENSTRUAL_HEALTH_KEYS.MENSTRUAL_CYCLE:
        trackPageViewGA('/menstrual-health/menstrual-cycle', 'MDQ-Menstrual Health - Menstrual Cycle');
        return <Questionnaire6Screen />;
      case MENSTRUAL_HEALTH_KEYS.CHOOSE_ILLNESS:
        trackPageViewGA('/menstrual-health/choose-illness', 'MDQ-Menstrual Health - Choose Illness');
        return <Questionnaire7Screen />;
      case MENSTRUAL_HEALTH_KEYS.SELECT_SYMPTOMS:
        trackPageViewGA('/menstrual-health/select-symptoms', 'MDQ-Menstrual Health - Select Symptoms');
        return <Questionnaire8Screen />;
      case MENSTRUAL_HEALTH_KEYS.HOW_TO_DEAL:
        trackPageViewGA('/menstrual-health/how-to-deal', 'MDQ-Menstrual Health - How To Deal');
        return <Questionnaire9Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default MenstrualHealth;
